import {Inject, Injectable} from "@angular/core";
import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";

export class EntityImportAction {
    constructor(public data: string) {
    }
}

export class EntityImportActionResp {
    id: string;
}

/**
 * Action Service to import entities
 */
@Injectable()
export class EntityImportService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "entity-import");
    }
}
